module.exports = __webpack_public_path__ + "static/media/Clawitzer_gaussian2.2f4eee8e.png";